import { ContextInfo } from '@system/context';

export interface HubUserContextInfo {
  userId?: number;
  sysUserId?: number;
  tenantId?: number;
  context?: ContextInfo;
}

export const HubHandlerSourceAngularJS: string = 'AngularJS';
export const HubHandlerSourceAngular: string = 'Angular';
export type HubHandlerSource = typeof HubHandlerSourceAngularJS | typeof HubHandlerSourceAngular;

export type HubHandlerMethod = (...args: any[]) => any;
